module.exports = __webpack_public_path__ + "static/laundry-1398c2a99b4a6b3d30ab0964b4829bda.png";